import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";
import MobileSidebar from "./MobileSidebar";
import BottomNavbar from "../shared/BottomNavbar";
import { bottomNavbarItems } from "../lib/constants";

const ProtectedRoute = () => {
  const isAuthenticated = !!Cookies.get("token");

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className=" h-dvh min-h-dvh  flex justify-center items-center bg-primary-50 md:p-4 ">
      <div className="flex flex-col   gap-1  md:gap-4 bg-white md:rounded-3xl p-1 md:p-3 shadow-xl w-full h-full md:w-[560px]">
        <MobileSidebar />

        <div className="flex-1 overflow-y-auto no-scrollbar w-full    bg-neutral-10 space-y-1 p-[6px] md:p-[10px] rounded-3xl  ">
          <Outlet />
        </div>
        <div className="sticky bottom-0 z-[80]   bg-primary-30 p-1 rounded-[18px] h-fit text-title-sm-regular flex items-center md:px-4 gap-4 md:gap-2 justify-between">
          <BottomNavbar sidebaritems={bottomNavbarItems} />
        </div>
      </div>
    </div>
  );
};

export default ProtectedRoute;
